import React from 'react';

import { EditOutlined, PreviewOutlined } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { useEditMode } from '@wp-block-builder/editor/hooks';

export default function EditModeGroup() {
  const [editMode, setEditMode] = useEditMode();

  const onEditChange = (ev: React.MouseEvent, value: unknown) => {
    ev.stopPropagation();
    switch (value) {
      case 'EDIT':
        setEditMode('EDIT');
        break;
      case 'PREVIEW':
        setEditMode('PREVIEW');
        break;
    }
  };

  return (
    <ToggleButtonGroup value={editMode} exclusive onChange={onEditChange} size="small">
      <ToggleButton value="EDIT">
        <Tooltip title="Edit mode">
          <EditOutlined fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="PREVIEW">
        <Tooltip title="Preview mode">
          <PreviewOutlined fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
